module.exports = __webpack_public_path__ + "static/media/dominos.5b1812e5.svg";